import { render, staticRenderFns } from "./EmpleadosInactivos.vue?vue&type=template&id=e86e36c4&scoped=true"
import script from "./EmpleadosInactivos.vue?vue&type=script&lang=js"
export * from "./EmpleadosInactivos.vue?vue&type=script&lang=js"
import style0 from "./EmpleadosInactivos.vue?vue&type=style&index=0&id=e86e36c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86e36c4",
  null
  
)

export default component.exports